import classnames from 'classnames'
import { useContext, useRef } from 'react'
import { useAuth } from '../utils/auth'
import { t } from '../utils/i18n'
import styles from './_pcoButton.module.scss'
import planingCenterIcon from '../../public/images/planning-center-black@2x.svg'
import Image from 'next/legacy/image'
import { ModalsContext } from '../utils/modals'
import { withLogin } from '../utils/auth/withLogin'
import { usePcoAuthMessageHandler } from '../utils/hooks/usePcoAuthMessageHandler'

interface PcoAuthButtonProps {
  inList?: boolean
  onAuthSuccess?: () => void
}

const PcoAuthButton: React.FC<PcoAuthButtonProps> = ({
  inList = false,
  onAuthSuccess
}) => {
  const { currentUser } = useAuth()
  const { openModal, closeModal } = useContext(ModalsContext)
  const authWindowRef = useRef<Window | null>(null)

  usePcoAuthMessageHandler({ onAuthSuccess })

  const handleClick = () => {
    authWindowRef.current = window.open(
      `${process.env.NEXT_PUBLIC_OLD_URL}/back/auth/pco/new`,
      '_blank'
    )
  }

  return (
    <button
      onClick={() => {
        withLogin(handleClick, currentUser, openModal, closeModal)
      }}
      className={
        inList
          ? classnames(styles.inList, styles.tooltip)
          : classnames('button', 'is-wide', 'is-transparent')
      }
    >
      <div className={styles.iconContainer}>
        <Image
          src={planingCenterIcon}
          className={styles.planingCenterIcon}
          alt={t('Connect Planning Center Online')}
          height={40}
          width={40}
          layout="fixed"
        />
      </div>
      {inList ? (
        <div className={styles.tooltipInfoBox}>
          <div className={styles.tooltipText}>
            {t('Connect Planning Center Online')}
          </div>
        </div>
      ) : (
        t('Connect PCO')
      )}
    </button>
  )
}

export default PcoAuthButton
